<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text"
                 name="name"
                 ref="name"
                 class="form-control"
                 @blur="generateKey"
                 v-validate="modelValidations.name"
                 v-model.trim="edit.name">
          <small class="text-danger" v-show="errors.has('name')">
            {{ getError('name') }}
          </small>
        </div>
        <div class="form-group">
          <label style="display:inline">Key</label>
          <input type="text"
                 name="key"
                 class="form-control"
                 v-validate="modelValidations.key"
                 v-model.trim="edit.key">
          <small class="text-danger" v-show="errors.has('key')">
            {{ getError('key') }}
          </small>
        </div>
        <hr />
        <div class="form-search">
          <el-autocomplete
            style="width:100%"
            name="digitalFormToAdd"
            class="inline-input"
            :clearable="true"
            v-model="formFieldToAdd"
            :fetch-suggestions="findFormFields"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Form Field Name"
            @select="addFormField">
          </el-autocomplete>
        </div>
        <div style="margin-top: 10px;" class="form-group field-values">
          <div>
            <el-table id="form-fields-table" class="table-striped"
                      row-key="id"
                      :data="edit.formFields"
                      row-class-name="draggable"
                      border
                      style="width: 100%">
              <el-table-column key="label"
                               prop="label"
                               label="Label">
                <template slot-scope="props">
                  {{ props.row.formFieldLabel }}
                </template>
              </el-table-column>
              <el-table-column
                width="110"
                fixed="right"
                label="Actions">
                <template slot-scope="props">
                  <div style="text-align: center">
                    <p-button type="danger" size="sm" icon @click="removeFormField(props.row)">
                      <i class="fa fa-times"></i>
                    </p-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-group">
          <button type="submit" :disabled="isSubmitDisabled" @click.prevent="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save Form Field Block</button>
          <div class="form-group form-group-active-label">
            <label class="active-label">Active</label>
            <p-switch v-model="edit.active" type="primary" on-text="YES" off-text="NO"></p-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {sync} from 'vuex-pathify'
import PSwitch from 'src/components/UIComponents/Switch'
import {autocompleteReady, camelize, notifyError, notifySuccess, sortableTable, sortBySort} from '@/utilities/utils'
import {mapGetters} from 'vuex'
import {OK, CREATED} from 'http-status-codes'

export default {
  props: ['data'],
  components: {
    PSwitch
  },
  computed: {
    edit: sync('inspectorApp/formFieldBlocks@edit'),
    ...mapGetters({
      formFields: 'inspectorApp/formFields/autocompleteResults'
    }),
    isSubmitDisabled() {
      return this.isProcessing
    }
  },
  data() {
    return {
      formFieldToAdd: '',
      isProcessing: false,
      modelValidations: {
        name: {
          required: true,
          max: 128
        },
        key: {
          required: true,
          max: 128
        }
      }
    }
  },
  methods: {
    generateKey() {
      this.edit.key = camelize(this.edit.name)
    },
    formFieldLabel(id) {
      const formField = this.$store.get('inspectorApp/formFields/byId', id)

      if (formField) {
        return formField.label
      }

      return ''
    },
    async findFormFields(query, cb) {
      if (autocompleteReady(query)) {
        await this.$store.dispatch('inspectorApp/formFields/fetchAutoCompleteResults', query)
        cb(this.formFields)
      }
    },
    addFormField(selectedFormField) {
      this.$store.set('inspectorApp/formFieldBlocks/addFormField', selectedFormField)
      this.$store.set('inspectorApp/formFields/autocompleteResults', [])
      this.formFieldToAdd = ''
    },
    removeFormField(selectedFormField) {
      this.$store.set('inspectorApp/formFieldBlocks/removeFormField', selectedFormField.formFieldId)
    },
    async validateAndSubmit() {
      this.isProcessing = true

      if (await this.$validator.validateAll()) {
        const response = await this.$store.dispatch('save2', {
          endpoint: 'form-field-blocks',
          data: this.edit
        })

        if (CREATED === response.status) {
          this.saveSuccessful('addResult', response.data)
          return
        }

        if (OK === response.status) {
          this.saveSuccessful('updateResult', response.data)
          return
        }
        notifyError(this, 'Failed to Save Form Field Block', response.errors)
      }
      this.isProcessing = false
    },
    saveSuccessful(commitPath, data) {
      notifySuccess(this, 'Form Field Block Saved Successfully')
      this.$store.commit('inspectorApp/formFieldBlocks/' + commitPath, data)
      this.$store.commit('inspectorApp/formFieldBlocks/resetEdit')
      this.$emit('close')
    },
    loadSortableTable() {
      sortableTable('#form-fields-table .el-table__body-wrapper tbody', this.updateFormFieldSort)
    },
    updateFormFieldSort(sortedFields) {
      this.$store.commit('inspectorApp/formFieldBlocks/updateFormFieldsSort', sortedFields)
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    }
  },
  async mounted() {
    if (this.data && this.data.id) {
      const response = await this.$store.dispatch('fetchById', {
        endpoint: 'form-field-blocks',
        id: this.data.id
      })

      if (OK === response.status) {
        const formFieldBlock = response.data

        formFieldBlock.formFields.forEach((formFieldMeta) => {
          formFieldMeta.formFieldLabel = this.formFieldLabel(formFieldMeta.formFieldId)
        })
        formFieldBlock.formFields = sortBySort(formFieldBlock.formFields)

        this.$store.commit('inspectorApp/formFieldBlocks/hydrateEdit', formFieldBlock)
      }
    }

    this.loadSortableTable()
  },
  destroyed() {
    this.$store.commit('inspectorApp/formFieldBlocks/resetEdit')
  }
}
</script>
